// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OJk8htZ4IY_OkIK5cksA{flex-direction:column;gap:4px;display:flex}.DaX6EmkVg2kB3V1IdOPk{justify-content:space-between;align-items:center;width:320px;display:flex}.rSAJFPdwJawPmP_SzpmV{align-items:center;gap:4px;display:flex}.noYvFBT4s4USpMJ4IT4O{align-items:center;gap:10px;display:flex}.Py2sg66YnDU0l_U_2Ar8{color:var(--content-primary-primary)}.M_SoSiYplsUtY4WQ_SbO{color:var(--content-primary-tertiary)}.n6ulUcoGMtoa_afk0tkg{color:var(--content-primary-disabled)}.OFnoVIW3_5gwcYHL9QcE{background:var(--gray-10);border-radius:6px;height:8px;position:relative}.OFnoVIW3_5gwcYHL9QcE>div{z-index:1;border-radius:6px;position:absolute;top:0;bottom:0;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `OJk8htZ4IY_OkIK5cksA`,
	"info": `DaX6EmkVg2kB3V1IdOPk`,
	"info__container": `rSAJFPdwJawPmP_SzpmV`,
	"infoContainer": `rSAJFPdwJawPmP_SzpmV`,
	"info__data": `noYvFBT4s4USpMJ4IT4O`,
	"infoData": `noYvFBT4s4USpMJ4IT4O`,
	"info__count": `Py2sg66YnDU0l_U_2Ar8`,
	"infoCount": `Py2sg66YnDU0l_U_2Ar8`,
	"info__percent": `M_SoSiYplsUtY4WQ_SbO`,
	"infoPercent": `M_SoSiYplsUtY4WQ_SbO`,
	"info__title": `n6ulUcoGMtoa_afk0tkg`,
	"infoTitle": `n6ulUcoGMtoa_afk0tkg`,
	"bar": `OFnoVIW3_5gwcYHL9QcE`
};
export default ___CSS_LOADER_EXPORT___;
